/* global axios */
import ApiClient from '../ApiClient';

class CopilotFaqsAPI extends ApiClient {
  constructor() {
    super('copilot/faqs', { accountScoped: true });
  }

  get({ page = 1, search, documentId, status } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search,
        document_id: documentId,
        status,
      },
    });
  }
}

export default new CopilotFaqsAPI();
